import useAmplitudeTracking from 'src/shared/app/base/tracking/useAmplitudeTracking';

export default function AmplitudeProvider() {
  useAmplitudeTracking();
}
